var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9356 22.7098H12.0645C11.3105 22.7098 10.6936 22.1131 10.6936 21.3838V20.681C10.6936 19.9517 11.3105 19.355 12.0645 19.355H12.9356C13.6895 19.355 14.3065 19.9517 14.3065 20.681V21.3838C14.3065 22.1132 13.6895 22.7098 12.9356 22.7098Z",
    fill: "#898890"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.153 21.2901H10.8471C10.3368 21.2901 9.91936 20.8664 9.91936 20.3485V19.7417H15.0806V20.3485C15.0806 20.8664 14.6632 21.2901 14.153 21.2901Z",
    fill: "#B39A7C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8548 8.63152C19.8548 4.55849 16.5314 1.26016 12.4436 1.29074C8.40641 1.32094 5.12671 4.6363 5.14524 8.66591C5.15559 10.9218 6.18558 12.937 7.79873 14.2767C8.71782 15.04 9.26196 16.1619 9.26196 17.3553V18.8389H15.7381V17.334C15.7381 16.1509 16.2794 15.0397 17.1918 14.2845C18.8186 12.9382 19.8548 10.9057 19.8548 8.63152Z",
    fill: "#FFED6E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9807 18.5806H9.01919C8.30785 18.5806 7.7258 18 7.7258 17.2903C7.7258 16.5807 8.3078 16 9.01919 16H15.9808C16.6921 16 17.2742 16.5806 17.2742 17.2903C17.2741 18 16.6921 18.5806 15.9807 18.5806Z",
    fill: "#D0D0D0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8373 19.9999H10.1627C9.53209 19.9999 9.01613 19.5313 9.01613 18.9587V18.5806H15.9839V18.9587C15.9839 19.5314 15.4679 19.9999 14.8373 19.9999Z",
    fill: "#C0AB91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLight);
export default __webpack_public_path__ + "static/media/light.8f81b85233563016032f67a6b24f5b68.svg";
export { ForwardRef as ReactComponent };